import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';

import { WidgetType } from 'widgets/WidgetType';
import { selectIntraDayProfileState } from 'widgets/intraDayProfile/store/selectors';
import {
    initialIntraDayProfileConfiguration,
    IntraDayProfileConfiguration,
} from 'widgets/intraDayProfile/store/configuration/IntraDayProfileConfiguration';

export const buildIntraDayProfileConfigSlice = () =>
    buildConfigSlice<IntraDayProfileConfiguration>(
        WidgetType.INTRA_DAY_PROFILE,
        selectIntraDayProfileState,
        initialIntraDayProfileConfiguration
    );

export const useIntraDayProfileConfigSlice = () =>
    useConfigSlice(buildIntraDayProfileConfigSlice());

export type IntraDayProfileConfigPayloadType =
    WidgetConfigSliceActionPayloadType<IntraDayProfileConfiguration>;
